function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Box, ChevronLeftIcon, Flex, HStack, Link, Progress, Stack, Text, VStack } from 'native-base';
import React, { memo, useContext, useEffect } from 'react';
import RadioCard from '../RadioCard';
import { NavigationContext } from '../../contexts';
const RadioCardGroup = _ref => {
  let {
    id,
    title,
    valueKey,
    metadata,
    navigation: {
      current,
      next,
      back
    },
    enableFooter
  } = _ref;
  const {
    onSelected,
    total,
    selected,
    logUserEvent,
    type,
    setStep
  } = useContext(NavigationContext);
  useEffect(() => {
    logUserEvent({
      type,
      action: id
    });
  }, [id, logUserEvent, type]);
  return /*#__PURE__*/React.createElement(Flex, {
    wrap: "wrap",
    direction: "column",
    align: "center",
    key: id
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    color: 'blue.1000',
    fontSize: '4xl',
    fontWeight: 'light',
    accessibilityLabel: title,
    testID: `radio-card-group-${title}`,
    mb: "5"
  }, title)), /*#__PURE__*/React.createElement(VStack, {
    w: {
      sm: '100%',
      base: '100%',
      md: undefined,
      lg: undefined
    },
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(VStack, {
    space: "2xs",
    w: "100%",
    mb: "8"
  }, /*#__PURE__*/React.createElement(Progress, {
    value: Math.ceil(100 / total * current),
    h: "2",
    bg: "white.700",
    borderColor: "border.light",
    borderWidth: "0.25",
    _filledTrack: {
      bg: '#1B68A5'
    },
    accessibilityLabel: 'progress bar',
    accessibilityRole: "progressbar",
    testID: `radio-card-group-${title}`
  }), /*#__PURE__*/React.createElement(Text, {
    textAlign: "right",
    fontFamily: "body",
    fontWeight: "medium",
    fontSize: "sm",
    color: "navyblue.500",
    accessibilityLabel: `step ${current} out of ${total}`
  }, `${current}/${total}`)), /*#__PURE__*/React.createElement(Stack, {
    direction: {
      sm: 'column',
      md: 'row',
      lg: 'row'
    },
    space: "6",
    w: {
      md: '2xl',
      lg: '2xl'
    },
    flexWrap: 'wrap'
  }, metadata.map(item => /*#__PURE__*/React.createElement(RadioCard, _extends({
    key: item.id
  }, item, {
    isActive: selected ? item.value === selected[valueKey] : false,
    setActive: (value, label) => {
      logUserEvent({
        type,
        action: `${item.id}Clicked`
      });
      onSelected({
        value: {
          [valueKey]: value,
          label
        },
        navigation: {
          action: 'next',
          next,
          back
        }
      });
    }
  })))), enableFooter ? /*#__PURE__*/React.createElement(HStack, {
    alignSelf: {
      sm: 'center',
      md: 'start',
      lg: 'start'
    },
    alignItems: 'center',
    mt: '5',
    mb: '5',
    width: "100%"
  }, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    color: "blue.400",
    size: "5"
  }), /*#__PURE__*/React.createElement(Link, {
    onPress: () => setStep(back),
    accessibilityLabel: "back",
    accessibilityRole: "link",
    _text: {
      fontSize: 'lg',
      color: 'blue.400',
      textDecoration: 'none'
    }
  }, "Back")) : null));
};
export default /*#__PURE__*/memo(RadioCardGroup);
//# sourceMappingURL=index.js.map